/**
 * Wann nach der Zusammenfassung gefragt wird (PO 09.09.2026: „wenn ein Vorgang
 * erledigt, dann Zusammenfassungs-Popup").
 *
 * Reine Funktion, damit die Bedingung prüfbar ist, ohne die halbe Detailseite
 * zu rendern. Sie ist heikler, als sie klingt: der Status kommt SERVERSEITIG
 * abgeleitet (`deriveVorgangStatus`) und wechselt auf zwei ganz verschiedenen
 * Wegen — durch den Knopf am To-do-losen Vorgang und dadurch, dass das letzte
 * To-do abgehakt wird. Beide sollen fragen; das bloße ÖFFNEN eines längst
 * erledigten Vorgangs nicht.
 */

export const ERLEDIGT = "Erledigt";

/**
 * @param vorher   Der zuletzt gesehene Status, `null` beim ersten Laden.
 * @param jetzt    Der frisch geladene Status.
 * @param bereits  Die schon gespeicherte Zusammenfassung.
 */
export function zusammenfassungFaellig(
    vorher: string | null,
    jetzt: string | null | undefined,
    bereits: string | null | undefined,
): boolean {
    // Erstes Laden: es gab keinen ÜBERGANG, nur einen Zustand. Sonst spränge
    // der Dialog bei jedem Öffnen eines abgeschlossenen Vorgangs auf.
    if (vorher === null) return false;
    if (vorher === ERLEDIGT || jetzt !== ERLEDIGT) return false;
    // Steht schon etwas, ist die Frage beantwortet — auch wenn jemand den
    // Vorgang wieder öffnet und erneut abschließt. Ändern geht über die Karte.
    return !(bereits ?? "").trim();
}
